"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var stimulus_1 = require("stimulus");
var lodash_1 = require("lodash");
var stimulus_2 = require("@hikakaku/shared/util/stimulus");
var React = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var after_search_content_modal_1 = __importDefault(require("~/components/blog/after_search_content_modal"));
var after_search_content_modal_for_business_1 = __importDefault(require("~/components/blog/after_search_content_modal_for_business"));
var google_analytics_manager_1 = __importDefault(require("@hikakaku/shared/util/google_analytics_manager"));
var KEY_CODE_ENTER = 13;
var HIGHLIGHT_CLASS = 'blogcontent-highlight';
var FOCUSED_HIGHLIGHT_CLASS = 'blogcontent-focused-highlight';
var HIGHLIGHT_WRAPPER_CLASS = 'blogcontent-highlight-wrapper';
var SEARCH_RESULT_CLASS = '.js-blog-search-content-controller-search-result';
var SearchContentController = /** @class */ (function (_super) {
    __extends(SearchContentController, _super);
    function SearchContentController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.scrollAnimateId = 0;
        _this.searchWord = '';
        _this.gaPostedSearchWord = '';
        _this.connect = function () {
            var _a;
            (_a = _this.inputTargets) === null || _a === void 0 ? void 0 : _a.forEach(function (inputTarget) {
                inputTarget.addEventListener('keydown', (0, lodash_1.debounce)(_this.handleKeyDown, 100));
            });
        };
        _this.handleKeyDown = function (e) {
            var target = e.target;
            var searchWord = target.value;
            if (_this.searchWord !== searchWord) {
                _this.searchWord = searchWord;
                _this.resetHighlight();
                if (searchWord) {
                    var highlightedCount = _this.highlight(searchWord);
                    var resultMessage = highlightedCount === 0 ? '該当する検索結果はありません' : '';
                    _this.setSearchResultMessage(target, resultMessage);
                }
            }
            if (e.keyCode === KEY_CODE_ENTER) {
                _this.scrollToNextHighlight();
                _this.postGAEvent();
            }
        };
        _this.handleClickSearchButton = function () {
            _this.scrollToNextHighlight();
            _this.postGAEvent();
        };
        _this.highlight = function (searchWord) {
            var textNodes = _this.searchTextNodes(searchWord);
            textNodes.forEach(function (textNode) {
                var _a;
                var highlightWrapper = document.createElement('span');
                highlightWrapper.classList.add(HIGHLIGHT_WRAPPER_CLASS);
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                highlightWrapper.innerHTML = textNode.textContent.replace(new RegExp(searchWord, 'g'), "<span class=\"".concat(HIGHLIGHT_CLASS, "\">").concat(searchWord, "</span>"));
                (_a = textNode.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(highlightWrapper, textNode);
            });
            return textNodes.length;
        };
        _this.resetHighlight = function () {
            var highlightWrappers = _this.element.querySelectorAll(".".concat(HIGHLIGHT_WRAPPER_CLASS));
            highlightWrappers.forEach(function (highlightWrapper) {
                var _a;
                var textNode = document.createTextNode(highlightWrapper.textContent || '');
                (_a = highlightWrapper.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(textNode, highlightWrapper);
            });
        };
        _this.searchTextNodes = function (searchWord) {
            var textNodes = [];
            (0, jquery_1.default)(_this.element).find(":contains('".concat(searchWord, "')")).each(function (index, node) {
                node.childNodes.forEach(function (child) {
                    var _a;
                    if (child.nodeType === Node.TEXT_NODE && ((_a = child.textContent) === null || _a === void 0 ? void 0 : _a.includes(searchWord))) {
                        textNodes.push(child);
                    }
                });
            });
            return textNodes;
        };
        _this.setSearchResultMessage = function (inputTarget, message) {
            var _a, _b;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            var elem = (_b = (_a = inputTarget.parentNode) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.querySelector(SEARCH_RESULT_CLASS);
            if (elem) {
                elem.innerText = message;
            }
        };
        _this.scrollToNextHighlight = function () {
            var _a;
            var highlightElements = _this.element.querySelectorAll(".".concat(HIGHLIGHT_CLASS));
            var prevFocusedIndex = (0, lodash_1.findIndex)(highlightElements, function (elem) { return elem.classList.contains(FOCUSED_HIGHLIGHT_CLASS); });
            var prevFocusedTarget = highlightElements[prevFocusedIndex];
            var currentFocusedTarget = highlightElements[(prevFocusedIndex + 1) % highlightElements.length];
            if (prevFocusedTarget) {
                prevFocusedTarget.classList.remove(FOCUSED_HIGHLIGHT_CLASS);
            }
            if (currentFocusedTarget) {
                currentFocusedTarget.classList.add(FOCUSED_HIGHLIGHT_CLASS);
                _this.unregisterOpenAfterSearchContentModal();
                var scrollAnimateId_1 = ++_this.scrollAnimateId;
                (0, jquery_1.default)("html,body").stop().animate({
                    scrollTop: (((_a = (0, jquery_1.default)(currentFocusedTarget).offset()) === null || _a === void 0 ? void 0 : _a.top) || 150) - 150,
                }, 500).promise().then(function () { return _this.handleScrollComplete(scrollAnimateId_1); });
            }
        };
        _this.handleScrollComplete = function (scrollAnimateId) {
            // スクロール直後だと、そのまま scroll が発火してしまうので 100ms の猶予を与える
            setTimeout(function () {
                if (_this.scrollAnimateId === scrollAnimateId) {
                    _this.registerOpenAfterSearchContentModal();
                }
            }, 100);
        };
        _this.registerOpenAfterSearchContentModal = function () {
            document.addEventListener('scroll', _this.openAfterSearchContentModal);
        };
        _this.unregisterOpenAfterSearchContentModal = function () {
            document.removeEventListener('scroll', _this.openAfterSearchContentModal);
        };
        // 初回スクロール時にモーダルを出す
        _this.openAfterSearchContentModal = (0, lodash_1.once)(function () {
            var _a;
            var modalElement = document.createElement('div');
            var componentName = _this.data.get('modalComponentName');
            var props = (0, stimulus_2.parseAttribute)(_this, 'blog-SearchContentModalProps');
            switch (componentName) {
                case 'AfterSearchContentModal':
                    react_dom_1.default.render(React.createElement(after_search_content_modal_1.default, __assign({}, props)), modalElement);
                    break;
                case 'AfterSearchContentModalForBusiness':
                    react_dom_1.default.render(React.createElement(after_search_content_modal_for_business_1.default, __assign({}, props)), modalElement);
                    break;
                default:
            }
            (_a = _this.element) === null || _a === void 0 ? void 0 : _a.append(modalElement);
        });
        _this.postGAEvent = function () {
            if (_this.searchWord !== _this.gaPostedSearchWord) {
                _this.gaPostedSearchWord = _this.searchWord;
                google_analytics_manager_1.default.postGAEventWithValue('ページ内検索', 'pagesearch', [_this.data.get('categoryName'), location.href].join(), _this.searchWord);
            }
        };
        return _this;
    }
    SearchContentController.targets = ['input'];
    return SearchContentController;
}(stimulus_1.Controller));
exports.default = SearchContentController;
